import { PublicAccountPaymentMethod } from "../types/public-accounts-api.types";
import type { NewPublicAccountFormData } from "../types/new-public-account.types";
import { getPaymentMethodFieldsForAccount } from "../constants/bankOptionsByCountry";
import { shouldShowAccountTypeAndNumberFields } from "../constants/public-accounts.constants";

export type NewPublicAccountFormErrors = Partial<
  Record<
    Exclude<
      keyof NewPublicAccountFormData,
      "methodFields" | "existing_attachment_urls"
    >,
    string
  >
> & { methodFields?: Record<string, string> };

export function validateNewPublicAccountForm(
  data: NewPublicAccountFormData
): NewPublicAccountFormErrors {
  const errors: NewPublicAccountFormErrors = {};
  if (!data.country_code?.trim()) {
    errors.country_code = "El país es obligatorio.";
  }
  if (!data.currency?.trim()) {
    errors.currency = "La moneda es obligatoria.";
  }
  if (!data.payment_method) {
    errors.payment_method = "El método de pago es obligatorio.";
  }
  if (data.payment_method === PublicAccountPaymentMethod.BANK) {
    if (!data.bank_name?.trim()) errors.bank_name = "El nombre del banco es obligatorio.";
    const methodFieldsConfig = getPaymentMethodFieldsForAccount(
      data.country_code,
      data.bank_name
    );
    const showAccountTypeAndNumber = shouldShowAccountTypeAndNumberFields(
      data.country_code,
      data.bank_name
    );
    if (methodFieldsConfig.length > 0) {
      if (showAccountTypeAndNumber) {
        if (!data.account_type?.trim())
          errors.account_type = "El tipo de cuenta es obligatorio.";
        if (!data.account_number?.trim())
          errors.account_number = "El número de cuenta es obligatorio.";
      }
      const methodFieldErrors: Record<string, string> = {};
      const methodFields = data.methodFields ?? {};
      for (const field of methodFieldsConfig) {
        if (field.id === "tipoCuenta" || field.id === "numeroCuenta") continue;
        if (field.required && !(methodFields[field.id]?.trim())) {
          methodFieldErrors[field.id] = `El campo ${field.label} es obligatorio.`;
        }
      }
      if (Object.keys(methodFieldErrors).length > 0) {
        errors.methodFields = methodFieldErrors;
      }
    } else {
      if (showAccountTypeAndNumber && !data.account_number?.trim())
        errors.account_number = "El número de cuenta es obligatorio.";
    }
  }
  if (data.payment_method === PublicAccountPaymentMethod.CRYPTO_WALLET) {
    if (!data.wallet_address?.trim())
      errors.wallet_address = "La dirección de la wallet es obligatoria.";
    if (!data.network?.trim()) errors.network = "La red es obligatoria.";
  }
  return errors;
}
